import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

const STATUS_CODE_404 = 404;

export const updateStudentConfig = ({ payload, studentId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/cp-config/student/${studentId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCPDistrictConfig = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/cp-config/district/config/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(e =>
      e?.response?.status === STATUS_CODE_404 ? {} : handleError(e),
    );

export const getProgressionRules = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/cp-config/progression-rules/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateCPDistrictConfig = ({ version = 'v1', data }) =>
  client
    .request({
      url: `${version}/cp-config/district/config/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCPEligibilityStatus = ({ version = 'v3' }) =>
  client
    .request({
      url: `${version}/cp-config/student-status/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPublicCourseCatalogContext = ({
  version = 'v1',
  districtSlug,
  params = {},
}) =>
  client
    .request({
      url: `${version}/cp-config/${districtSlug}/public-course-catalog-context/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
